import { createAction, props } from "@ngrx/store";
import { MsvLetterAttributes } from '../../create-request/models/Standing-Authorizations/LettersResponse';
import { ServiceError } from "../../create-request/models/shared/ServiceError";
import { JsonApiListWrap } from "../../shared/models/JsonApiWrap";
import { MsvTransactionAttributes } from "../../create-request/models/master-status-view/TransactionsResponse";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";

export const refreshSaMaster = createAction(
  '[Master Standing Auth Status View] Refresh master account data',
  props<{ masterAccountId: string }>()
);

export const callLetters = createAction(
  '[Master Standing Auth Status View] Get the list of master status view standing authorizations'
);

export const callLettersSuccess = createAction(
  '[Master Standing Auth Status View] Letters loaded successfully',
  props<JsonApiListWrap<MsvLetterAttributes>>()
);

export const callLettersFailure = createAction(
  '[Master Standing Auth Status View] Failed to load letters',
  props<ServiceError>()
);

export const callLettersEmptyResponse = createAction(
  '[Master Standing Auth Status View] Letters response is empty'
);

export const getBookmarkedAccounts = createAction(
    '[Master Standing Auth Status View] Retrieve bookmarked accounts',
    props<{isBookmarkFilterOn: boolean}>()
);

export const callBookmarkedAccountsSuccess = createAction(
    '[Master Standing Auth Status View] Bookmarked Accounts Loaded Successfully',
      props<JsonApiListWrap<MsvLetterAttributes>>()
);

export const callSaMsvInternalTransferInquiry = createAction(
  '[Master Standing Auth Status View - View Page] Call internal transfer inquiry',
  props<{ payload: MsvTransactionAttributes, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callSaMsvCheckInquiry = createAction(
  '[Master Standing Auth Status View - View Page] Call check inquiry',
  props<{ payload: MsvTransactionAttributes, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callSaMsvAchInquiry = createAction(
  '[Master Standing Auth Status View - View Page] Call ACH inquiry',
  props<{ payload: MsvTransactionAttributes, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callSaMsvWireInquiry = createAction(
  '[Master Standing Auth Status View - View Page] Call Wire inquiry',
  props<{ payload: MsvTransactionAttributes, viewType: ViewTypes, transactionType: transactionTypes,  resourceVersion: string }>()
);


